import { useState } from "react";
import useScrollTop from "../../hooks/useScrollTop";
import "./styles/FaqPage.css";
import { BiChevronDown } from "react-icons/bi";
import { useTranslation, Trans } from "react-i18next";
import "../../localisation/index";

const FaqPage = () => {
  const {t} = useTranslation()
  const [activeSection, setActiveSection] = useState({});

  useScrollTop();

  // to handle active section
  const handleActive = (event) => {
    event.preventDefault();
    const id = event.target.id;
    setActiveSection((prev) => ({
      ...prev,
      [id]: prev.hasOwnProperty(id) ? !prev[id] : true,
    }));
  };

  return (
    <div className="component">
      <div className="component-primary-heading">{t("faqPage.faqs")}</div>

      <div className="faq-component">
        <div className="faq-sections">
          <div className="faq-section__title" onClick={handleActive} id="about">
            {t("faqPage.aboutCompany")}{" "}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.about ? "icon_up" : ""
              }`}
            />
          </div>
          {activeSection?.about && (
            <ul>
              <Trans i18nKey="faqPage.functionalities" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img:  <img /> }} />
            </ul>
          )}
        </div>

        <div className="faq-sections">
          <div
            onClick={handleActive}
            id="onboarding"
            className="faq-section__title"
          >
            {t("faqPage.merchantOnboard")}{" "}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.onboarding ? "icon_up" : ""
              }`}
            />
          </div>
          {activeSection?.onboarding && (
            <ol>
              <Trans i18nKey="faqPage.onboardingFeatures" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img:  <img /> }} />
            </ol>
          )}
        </div>

        <div className="faq-sections">
          <div
            onClick={handleActive}
            id="configuration"
            className="faq-section__title"
          >
            {t("faqPage.configurationTitle")}{" "}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.configuration ? "icon_up" : ""
              }`}
            />
          </div>

          {activeSection?.configuration && (
            <div className="tableBody">
              <table>
                <Trans i18nKey="faqPage.configurationFeatures" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img:  <img /> }} />
              </table>
            </div>
          )}
        </div>

        <div className="faq-sections">
          <div
            onClick={handleActive}
            id="purchase"
            className="faq-section__title"
          >
            {t("faqPage.giftCardRedemption")}{" "}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.purchase ? "icon_up" : ""
              }`}
            />
          </div>
          {activeSection?.purchase && (
            <ol>
              <Trans i18nKey="faqPage.giftCardRedemption" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img:  <img /> }} />
            </ol>
          )}
        </div>

        <div className="faq-sections">
          <div
            onClick={handleActive}
            id="storecredits"
            className="faq-section__title"
          >
            {t("faqPage.storeCredit")}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.storecredits ? "icon_up" : ""
              }`}
            />
          </div>

          {activeSection.storecredits && (
            <ol>
              <Trans i18nKey="faqPage.storeCreditInfo" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img:  <img /> }} />
            </ol>
          )}
        </div>

        <div className="faq-sections">
          <div
            onClick={handleActive}
            id="report"
            className="faq-section__title"
          >
            {t("faqPage.merchantReports")}{" "}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.report ? "icon_up" : ""
              }`}
            />
          </div>
          {activeSection?.report && (
            <ol>
              <Trans i18nKey="faqPage.merchantReportsInfo" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img:  <img /> }} />
            </ol>
          )}
        </div>

        <div className="faq-sections">
          <div
            onClick={handleActive}
            id="billing"
            className="faq-section__title"
          >
            {t("faqPage.billing")}{" "}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.billing ? "icon_up" : ""
              }`}
            />
          </div>
          {activeSection?.billing && (
            <ol>
              <Trans i18nKey="faqPage.billingInfo" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img:  <img /> }} />
            </ol>
          )}
        </div>

        <div className="faq-sections">
          <div
            onClick={handleActive}
            id="support"
            className="faq-section__title"
          >
            {t("faqPage.customerSupport")}
            <BiChevronDown
              className={`faq-section__icon ${
                activeSection?.support ? "icon_up" : ""
              }`}
            />
          </div>
          {activeSection?.support && (
            <ol>
              <Trans i18nKey="faqPage.customerSupportInfo" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, ul: <ul />, li: <li />, table: <table />, tr: <tr />, th: <th />, td: <td />, a: <a />, b: <b />, img: <img /> }} />
            </ol>
          )}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
